import { render, staticRenderFns } from "./EditorStyleGuide.vue?vue&type=template&id=2f74c1ee&scoped=true&"
import script from "./EditorStyleGuide.vue?vue&type=script&lang=js&"
export * from "./EditorStyleGuide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f74c1ee",
  null
  
)

export default component.exports